import { render, staticRenderFns } from "./EventsStatuses_new.vue?vue&type=template&id=f0026f50"
import script from "./EventsStatuses_new.vue?vue&type=script&lang=js"
export * from "./EventsStatuses_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports